<template>
  <div class="rb-help">
    <a
      href="#"
      @click.prevent="openPopup($event, 'rb-popup-help')"
      id="popup-open-help"
    >
      <span>Need help?</span>
      <icon-help />
    </a>
    <a
      href="#"
      @click.prevent="openPopup($event, 'rb-popup-shipping')"
      id="popup-open-shipping"
    >
      <span>Shipping &amp; Returns</span>
      <icon-shipping />
    </a>
  </div>
</template>
<script>
/**
 * Small widget to display help links
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @emits
 * rb-open-popup
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import IconHelp from "@/components/icons/IconHelp";
import IconShipping from "@/components/icons/IconShipping";
export default {
  mixins: [CommMixin, TrackMixin],
  components: { IconHelp, IconShipping },
  methods: {
    openPopup: function (event, id) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-open-popup", { id });
    },
  },
};
</script>
